import { Navigate } from "react-router-dom";
import { useAuth } from "../services/authService";
import {
  normalizeStatus,
  normalizeRole,
  canDownloadFirmware,
  canManageFirmware,
} from "../services/authz";

export default function ServiceRoute({ children }) {
  const { currentUser, userStatus, userRole } = useAuth();

  if (!currentUser) return <Navigate to="/login" replace />;

  const status = normalizeStatus(userStatus);
  const role = normalizeRole(userRole);

  // service_admin / super_admin / firmware_admin (dle authz)
  const canManage = canManageFirmware(status, role);
  if (canManage) return <Navigate to="/service-admin" replace />;

  const canRead = canDownloadFirmware(status, role);
  if (!canRead) return <Navigate to="/dashboard" replace />;

  return children;
}
